import axios from "@/api/axiosInstance";
import { FetchDiagnosticAttemptAuditResponse } from "./types";
import type { DiagnosticAuditEntry } from "../../types/diagnostic";

/**
 * Edit history for a completed attempt, newest change first. Empty for an
 * attempt that has never been corrected, which is why the screen only asks
 * for it when `editCount > 0`.
 */
export const fetchDiagnosticAttemptAudit = async (
  attemptId: number,
  signal?: AbortSignal,
): Promise<DiagnosticAuditEntry[]> => {
  const response = await axios.get<FetchDiagnosticAttemptAuditResponse>(
    `/api/private/attempts/${attemptId}/audit`,
    { signal },
  );
  return response.data.data.entries;
};
